import React from 'react';
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia, Section } from '../../components/imports';
import { create } from 'zustand';
import { twMerge } from 'tailwind-merge';

export const useLayer = create((set) => ({
  currentLayer: [],
  isActive: false,
  setActive: (id) =>
    set((state) => ({
      currentLayer: [...state.currentLayer, id],
      isActive: true,
    })),
  setInactive: (id) =>
    set((state) => {
      const updatedLayers = state.currentLayer.filter((layer) => layer !== id);
      return {
        currentLayer: updatedLayers,
        isActive: updatedLayers.length > 0,
      };
    }),
}));

const Content = () => {

  const layers = [
    { label: 'Arrière plan', value: '4', file: 'Arrière plan', css: '' },
    { label: 'Bracelet', value: '3', file: 'Bracelet', format: "png", css: '' },
    { label: 'Cadrant', value: '1', file: 'Cadrant', css: 'mix-blend-lighten' },
    { label: 'Effet Éclat', value: '2', file: 'Effet Éclat', css: 'mix-blend-screen' },
  ];

  const { /* isActive,  */currentLayer, setActive, setInactive } = useLayer();

  const toggleActive = (id) => {
    currentLayer.includes(id) ? setInactive(id) : setActive(id);
  };

  // const { R006ref } = useRef(null)

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <>
          <div className="projectContent">
            <div className='w-full bg-black paddingY'>
              <ImageMedia title="IngersollOverview" className="w-full resp" src={require('./assets/Ingersoll_R007_1080p.jpg')} />
            </div>

            <div className='flex flex-col w-full relative group center'>
              <h3 className='absolute w-fit flex mx-auto bottom-8 z-[2] '>Modélisation 3D</h3>
              <MotionContent height={"h-[110v]"} className={"relative"} translateRange={["-20%", "5%"]} >
                <ImageMedia src={require("./assets/x Ingersoll_RENDER_038VP.png")} dim hover className="object-cover relative" />
              </MotionContent>
            </div>

            <div className="w-full relative h-full flex flex-col paddingY=">
              <Section padded>
                <div className="flex flex-col resp gap-2 items-start w-full">
                  <h2>Essaye avec ton curseur</h2>
                  <h5 className="maxW2 group">
                    Voici 3 niveaux de rendus pour "COMPOSITING". Ce qui veut dire éditer différentes parties clés d'un rendu séparément : ce qu'on appelle une <span className='group-hover:text-red-400 oneSecond underline underline-offset-2'>correction non-destructive.</span> <br />
                    <br />
                    Si toutefois une modification conséquente est apportée, l'effort à fournir ne sera que sur la partie concernée et non l'image entière. <i>Et oui, c'est technique tout ça!</i>
                  </h5>
                </div>

                <div id="imageBuilder" className="h-[80vh] w-[80vw] m-auto flex center relative border border1 bg-gradient-to-t from-blakk rounded overflow-clip mt-10">
                  {!currentLayer.length &&
                    <h3 className="flex absolute fit items-center gap-3 m-auto">
                      Active ça toi-même.<i className="flex center size-8 bg-primary ri-sm rounded-full ri-arrow-down-line" />
                    </h3>
                  }

                  <div className="relative w-full h-full group">
                    {layers.map((layer, i) => {
                      const isActive = currentLayer.includes(layer.value);
                      return (
                        <div
                          key={layer.file}
                          className={twMerge(
                            'absolute inset-0 transition-opacity duration-500',
                            layer.css,
                            isActive ? 'opacity-100 z-[10]' : 'opacity-0 z-[1]'
                          )}
                        >
                          <div className="flex full relative center">
                            <ImageMedia
                              src={require(`./assets/layers/LAWWDxIngersoll_LayersWeb_0${layer.value}.${!layer.format ? "jpg" : "png"}`)}
                            />
                          </div>
                        </div>
                      );
                    })}
                    <div id="buttons" className={twMerge("flex absolute z-[20] origin-bottom scale-90 group-hover:scale-100 oneSecond bottom-0 mx-auto inset-x-0 w-fit padding gap-4 items-center", currentLayer.length === layers.length && "scale-50===")}>
                      {layers.map((layer) => {
                        const isActive = currentLayer.includes(layer.value);
                        return (
                          <button
                            key={layer.value}
                            onClick={() => toggleActive(layer.value)}
                            className={twMerge(
                              'px-2 py-1 text-white bg-black transition-all duration-300',
                              isActive && 'bg-white text-black rounded-md'
                            )}
                          >
                            <h4>{layer.label}</h4>
                          </button>
                        );
                      })}
                    </div>
                  </div>


                </div>
              </Section>
              {/* 
            <MotionContent imgRef={R006ref} height="h-[100vh]" className={"overflow-clip aspect-square"} translateRange={["15%", "20%"]} scaleRange={[2, 1]} >
              <ImageMedia title="R006" loading='eager' src={require('./assets/R006-Ingersoll.jpg')} className="flex-grow object-center !object-cover !full scale-[110%]" />
            </MotionContent> */}
            </div>
          </div>

          {/* <MotionContent height={"h-[100vh]"} className={"relative h-auto center"} translateRange={["15vh", "-20vh"]} scaleRange={[1.5, 1]} > */}
          <ImageMedia src={require('./assets/R006-Ingersoll.jpg')} className="h-full object-contain" />
          {/* </MotionContent> */}

          {/* <div className='h-[50vh] flex' /> */}

        </>

      )
      }
    </ThisProject >
  );
};

export default Content;
